import React, { useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode";

import Sidebar from "layouts/Sidebar";
import PanelNavbar from "layouts/PanelNavbar";
import "styles/panel.css";

const PanelLayout = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("accessToken");

    if (token) {
      try {
        const decoded = jwtDecode(token);

        setUser({
          name: decoded[
            "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"
          ],
          role: decoded[
            "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
          ],
          id: decoded[
            "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"
          ],
        });
      } catch {
        localStorage.removeItem("accessToken");
      }
    }
  }, []);

  if (!user) {
    return <div className="loading-screen">Yuklanmoqda...</div>;
  }

  return (
    <div className="panel-container">
      <Sidebar user={user} />
      <div className="main-content">
        <PanelNavbar user={user} />
        <section className="dashboard">{children}</section>
      </div>
    </div>
  );
};

export default PanelLayout;
